import { currencyFormatter } from "@/Utils/Currency";
import {
	displayPricingName,
	PricingOptions,
	ProductPricingPlan,
	ratailPriceLabel
} from "@/Contracts/Products";
import { ZTypography } from "@atoms";
import ZRadioGroup from "@atoms/ZRadioGroup";
import { IOptionProps } from "@atoms/ZRadioGroup/interface";
import React from "react";
import { IDistributorProductPricing } from "./interface";

const { ZText } = ZTypography;

const ZDistributorProductPricing: React.FC<IDistributorProductPricing> = ({
	pricing,
	selectedPricing,
	handlePricingChange,
	integratedDistributors
}) => {
	const catalogPricing = pricing.find(
		currentPricing => !currentPricing.distributor_pricing_details
	);

	const distributorPricing: IOptionProps[] = pricing
		.filter(currentPricing => !!currentPricing.distributor_pricing_details)
		.map((currentPricing, index) => {
			const distributorPricingDetails =
				currentPricing?.distributor_pricing_details;

			const retailPriceInfo =
				distributorPricingDetails?.distributor &&
					distributorPricingDetails?.retail_price
					? `${ratailPriceLabel[
					distributorPricingDetails?.distributor
					]
					}: ${currencyFormatter(
						distributorPricingDetails?.retail_price
					)}`
					: "";

			return {
				heading:
					index === 0 && integratedDistributors > 0
						? "Realtime pricing"
						: "",
				label: `${displayPricingName(currentPricing)}: ${currentPricing.cost_price !== null
						? `${currencyFormatter(currentPricing.cost_price)}`
						: "NA"
					}`,
				value: currentPricing.id ?? "",
				headingClassName: "mt-4",
				children: retailPriceInfo && (
					<ZText className="text-gray-7">{retailPriceInfo}</ZText>
				)
			};
		});

	const options: IOptionProps[] = catalogPricing
		? [
			{
				heading: "My catalog",
				label: catalogPricing?.name,
				value: PricingOptions.Catalog || "",
				headingClassName: "mt-4"
			}
		]
		: [];

	options.push(...distributorPricing);

	options.push({
		label: "Custom",
		value: PricingOptions.Custom,
		heading: "Create new",
		headingClassName: "mt-4"
	});

	const defaultSelectPricing = selectedPricing as ProductPricingPlan;

	const selectedValue = defaultSelectPricing?.id
		? defaultSelectPricing?.id
		: selectedPricing
			? selectedPricing
			: catalogPricing
				? PricingOptions.Catalog
				: PricingOptions.Custom;

	return (
		<div>
			<ZRadioGroup
				onChange={e => handlePricingChange(e.target.value)}
				options={options}
				vertical
				value={selectedValue}
				showAllChildren
				isRadioLabelWidthMax={false}
			/>
		</div>
	);
};

export default ZDistributorProductPricing;
